import * as Yup from 'yup';

const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}){1,2}$/;

const StoreAppearanceSchema = Yup.object().shape({
  customLogo: Yup.boolean(),
  topCoverImageUrl: Yup.string().nullable(),
  isCustomThemeEnabled: Yup.boolean(),
  themeMainColor: Yup.string()
    .nullable()
    .when('isCustomThemeEnabled', {
      is: true,
      then: (schema) =>
        schema
          .required('Main color is required')
          .matches(HEX_COLOR_REGEX, 'Main color must be a valid hex code'),
      otherwise: (schema) => schema.nullable()
    }),
  themeSecondaryColor: Yup.string()
    .nullable()
    .when('isCustomThemeEnabled', {
      is: true,
      then: (schema) =>
        schema
          .required('Secondary color is required')
          .matches(HEX_COLOR_REGEX, 'Secondary color must be a valid hex code'),
      otherwise: (schema) => schema.nullable()
    })
});

export default StoreAppearanceSchema;
